(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("handsontable"), require("react"));
	else if(typeof define === 'function' && define.amd)
		define(["handsontable", "react"], factory);
	else if(typeof exports === 'object')
		exports["HotTable"] = factory(require("handsontable"), require("react"));
	else
		root["HotTable"] = factory(root["Handsontable"], root["React"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_3__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition